import { License } from '../../types'

const licenses: License[] = [
	{
		consumed: 3,
		quantity: 15,
		serial: '4OCZSFPC',
		type: 'crm',
		end_customer_id: 10,
		partner_id: 'mondago',
		display_name: 'CRM integration',
		is_nfr: false,
	}
]

export default licenses
